/* eslint-disable no-param-reassign */
import React, { useEffect } from "react";
import CustomLayout from "../../General/CustomLayout/CustomLayout";
import ReportBuilderLeftSide from "./ReportBuilderLeftSide";
import ReportBuilderResult from "./ReportBuilderResult";
import useLandingPageHandler from "../../../hooks/useLandingPageHandler";
import { getMarketPackageCode } from "../../../utils/oneintelligence/OneIntelligenceHelper";
import { useDispatch, useSelector } from "react-redux";
import { setCollapseLSide, setExpandOverflow } from "../../../store/components/Expand.slice";
import { isViewer } from "../../../utils/MainHelper";

function ReportBuilder() {
    useLandingPageHandler();
    const dispatch = useDispatch();
    const { collapseLSide } = useSelector((state) => state.expandstore)
    const { reportIsLoading } = useSelector((state) => state.reports)

    const marketPackageCode = getMarketPackageCode();

    useEffect(() => {
        if (reportIsLoading) {
            if (marketPackageCode === "whitespaces") {
                dispatch(setCollapseLSide(true));
                dispatch(setExpandOverflow(false));
            } else {
                dispatch(setCollapseLSide(false));
            }
        }
    }, [marketPackageCode, reportIsLoading])

    return (
        <CustomLayout className={`reportBuilder ${marketPackageCode === "adtag" ? `${marketPackageCode}-mod` : marketPackageCode} ${collapseLSide ? "side-collapse" : ""} ${isViewer() ? "viewer" : ""}`}>
            {!isViewer() && <div className="reportBuilder-leftside">
                <ReportBuilderLeftSide />
            </div>}
            <div className="reportBuilder-content" >
                <ReportBuilderResult />
            </div>
        </CustomLayout>
    );
}
export default ReportBuilder;
